export default __webpack_public_path__ + "static/media/uulzalt3.bb7f95e0.png";